import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import { ListItem } from 'react-toolbox/lib/list'
import { Link } from 'react-router-dom'

import ApprovalItemDetails from './ApprovalItemDetails'
import ApprovalActions from './ApprovalActions'

import theme from './ApprovalItem.scss'

class ApprovalItem extends Component {
  itemDetails(){
    let {
      approval: {
        projectId,
        partnerSiteName,
        productSku,
        gpuSku,
        workflowId,
        id,
        riskStatus,
        productClassType
      }
    } = this.props
    return (
      <Link class={theme.approvalItemLink} to={`/project/approvals/${id}`}>
        <ApprovalItemDetails
          projectId={projectId}
          partnerSite={partnerSiteName}
          productSku={productSku}
          gpuSku={gpuSku}
          riskStatus={riskStatus}
          productClassType={productClassType}
        />
      </Link>
    )
  }

  approvalActions(){
    let {
      rejectApproval,
      acceptApproval,
      approval: {
        workflowId,
        id,
      }
    } = this.props

    return ([
      <ApprovalActions
        key='approval_actions'
        rejectApproval={ () => rejectApproval(workflowId, id) }
        acceptApproval={ () => acceptApproval(workflowId, id) }
      />
    ])
  }

  render(){
    let {
      selected
    } = this.props

    let classes = null
    if (selected) classes = theme.selected

    return(
      <ListItem
        class={classes}
        selectable
        ripple={ false }
        itemContent={ this.itemDetails() }
        rightActions={ this.approvalActions() }
        theme={ theme }
      />
    )
  }
}

ApprovalItem.propTypes = {
  approval: PropTypes.object.isRequired,
  rejectApproval: PropTypes.func.isRequired,
  acceptApproval: PropTypes.func.isRequired,
}

export default CSSModules(ApprovalItem, theme)
